import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout/layout.component';
import { RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	declarations: [ 
		LayoutComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule, 
		ReactiveFormsModule
	],
	exports: [ 	
		LayoutComponent
	]
})
export class SharedModule {}
